// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__3E3Z_","para":"Contact_para__fOK5L","main-btn":"Contact_main-btn__3tPcC"};